<div class="ut-dash">
  <div class="ut-dash__main">
    @if (showChecklist) {
      <ut-dashboard-checklist [user]="user" [testerAppUrl]="testerAppUrl"></ut-dashboard-checklist>
    }
    <ut-dashboard-activity-card [testerAppUrl]="testerAppUrl"></ut-dashboard-activity-card>
  </div>

  <div class="ut-dash__side">
    @if (showCompletion) {
      <ut-dashboard-profile-completion [user]="user" [testerAppUrl]="testerAppUrl"></ut-dashboard-profile-completion>
    }
    <ut-dashboard-my-devices [testerAppUrl]="testerAppUrl"></ut-dashboard-my-devices>
    <ut-dashboard-requested-devices></ut-dashboard-requested-devices>
  </div>
</div>
